export default "__VITE_ASSET__Be$En4lf__"